import { render, staticRenderFns } from "./RemoteAuthorization.vue?vue&type=template&id=0702e924&scoped=true&lang=pug&"
import script from "./RemoteAuthorization.vue?vue&type=script&lang=js&"
export * from "./RemoteAuthorization.vue?vue&type=script&lang=js&"
import style0 from "./RemoteAuthorization.vue?vue&type=style&index=0&id=0702e924&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0702e924",
  null
  
)

export default component.exports